module.exports = __webpack_public_path__ + "static/media/5.601e8caf.jpg";